class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
    document.body.classList.add('classic');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    document.body.classList.remove('classic');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
function cartdrawerpricelimit() {
  var drawertags = document.querySelector('.drawer__inner');
  var tagAttribute = drawertags.getAttribute("data-drawer-attribute");

   var drawertotalPriceElement = document.querySelector(".drawer__inner .totals__total-value");
  var totalPriceText = drawertotalPriceElement.innerHTML;

  var totalPriceWithoutCurrency = totalPriceText.replace("Rs.", "").replace(",", "").replace(" PKR", "").replace(".00", "");

  if (tagAttribute.includes("35000")) {
    if (parseInt(totalPriceWithoutCurrency) > 35001) {
  document.querySelector(".cart__ctas .cart__checkout-button.button").style.display = "none";
   // Create and insert the message div before the button being removed
    let messageText = "Total price exceeds your monthly shopping limit.";
    let messageDiv = document.createElement("div");
    messageDiv.className = "hidden-message-drawer";
    messageDiv.style.color = "red";
    messageDiv.textContent = messageText;


    let removeButton = document.querySelector(".cart__ctas .cart__checkout-button.button");
    removeButton.parentNode.insertBefore(messageDiv, removeButton.nextSibling);
    } else if (parseInt(totalPriceWithoutCurrency) < 35001) {
  document.querySelector(".drawer__inner .cart__ctas .cart__checkout-button.button").style.display = "block";
 // Remove the message div when the checkout button is visible
    let messageDiv = document.querySelector(".hidden-message-drawer");
    if (messageDiv) {
      messageDiv.parentNode.removeChild(messageDiv);
    }
    }
  } else if (tagAttribute.includes("50000")) {
    if (parseInt(totalPriceWithoutCurrency) > 50001) {
      document.querySelector(".cart__ctas .cart__checkout-button.button").style.display = "none";
   // Create and insert the message div before the button being removed
    let messageText = "Total price exceeds your monthly shopping limit.";
    let messageDiv = document.createElement("div");
    messageDiv.className = "hidden-message-drawer";
    messageDiv.style.color = "red";
    messageDiv.textContent = messageText;

      let removeButton = document.querySelector(".cart__ctas .cart__checkout-button.button");
    removeButton.parentNode.insertBefore(messageDiv, removeButton.nextSibling);
    }  else if (parseInt(totalPriceWithoutCurrency) < 55001) {
  document.querySelector(".drawer__inner .cart__ctas .cart__checkout-button.button").style.display = "block";
 // Remove the message div when the checkout button is visible
    let messageDiv = document.querySelector(".hidden-message-drawer");
    if (messageDiv) {
      messageDiv.parentNode.removeChild(messageDiv);
    }
    }
  }
}


// Call cartdrawerpricelimit() after a delay of 1000 milliseconds (1 second)

  cartdrawerpricelimit();


